import { render } from "./AposColor.vue?vue&type=template&id=5268bdb6&scoped=true"
import script from "./AposColor.vue?vue&type=script&lang=js"
export * from "./AposColor.vue?vue&type=script&lang=js"

import "./AposColor.vue?vue&type=style&index=0&id=5268bdb6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5268bdb6"],['__file',"color-field/ui/apos/components/AposColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5268bdb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5268bdb6', __exports__)) {
    api.reload('5268bdb6', __exports__)
  }
  
  module.hot.accept("./AposColor.vue?vue&type=template&id=5268bdb6&scoped=true", () => {
    api.rerender('5268bdb6', render)
  })

}


export default __exports__